import React from 'react';

import { Image as ImageComponent } from '../ImageComponent/ImageComponent';

const mockAssetImage = (src, alt) => ({
  alt: alt ?? null,
  copyright: null,
  fieldtype: 'asset',
  filename: src ? 'https:' + src : null,
  focus: null,
  id: null,
  name: '',
  title: null,
});

// This has been deprecated and is now used as a bridge to new component
export function Image({ src, alt, className, ...otherProps }) {
  return (
    <ImageComponent
      className={className}
      image={mockAssetImage(src, alt)}
      mobileImage={mockAssetImage()}
      minSize="400x0"
      {...otherProps}
    />
  );
}

export default Image;
